import { render } from "./InterventoDetail.vue?vue&type=template&id=332b3ce3&scoped=true"
import script from "./InterventoDetail.vue?vue&type=script&lang=js"
export * from "./InterventoDetail.vue?vue&type=script&lang=js"

import "./InterventoDetail.vue?vue&type=style&index=0&id=332b3ce3&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332b3ce3"]])

export default __exports__